// Counts a page view on every page (added by config/analytics.ts when analytics is on).
import { trackPageview } from './stats';

trackPageview();
